module.exports = __webpack_public_path__ + "static/media/service-list-1.4146b6f3.jpg";